import { render, staticRenderFns } from "./CargoClaimPost.vue?vue&type=template&id=30e6f15c&"
import script from "./CargoClaimPost.vue?vue&type=script&lang=js&"
export * from "./CargoClaimPost.vue?vue&type=script&lang=js&"
import style0 from "./CargoClaimPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoClaimPost.vue"
export default component.exports